import api from './api';

/**
 * Regra de bloqueio por fim de acesso, num lugar só.
 *
 * Quem já pagou em algum momento vê a modal de reativação, com a data em que a
 * conta ficou inativa; quem nunca pagou vê a oferta de primeira compra (cupom
 * BEMVINDO). As duas informações vêm da própria rota.
 *
 * Antes isso vivia só dentro da navbar, e por isso qualquer outro ponto de
 * bloqueio (os filtros do compêndio, por exemplo) mostrava sempre a modal de
 * trial — inclusive para quem já tinha sido cliente.
 */

// Consulta se a conta já foi cliente pagante. Sem cache: a rota é consultada a
// cada bloqueio, para refletir imediatamente uma reativação feita em outra aba.
// Em caso de erro, assume não-cliente (mantém o comportamento de exibir o cupom).
export const getIsClienteAntigo = async () => {
    try {
        const response = await api.get('/compra/is-cliente');
        const data = response?.data?.data || {};

        return {
            isCliente: !!data.isCliente,
            inativoDesde: data.inativo_desde || null,
        };
    } catch (error) {
        return { isCliente: false, inativoDesde: null };
    }
};

// Converte "YYYY-MM-DD" (vindo da API) para "DD/MM/AAAA"
export const formatDateBR = (isoDate) => {
    if (!isoDate) return '';

    const [year, month, day] = isoDate.split('-');
    return `${day}/${month}/${year}`;
};

// A API devolve em inativo_desde a data de bloqueio da conta
// (agro_softwares.data_bloqueio). Guarda contra data futura, que deixaria o texto
// sem sentido ("inativa desde" uma data que ainda não chegou) — caso possível só
// no fallback de contas bloqueadas antes da coluna existir, que ainda usam
// contracts.data_vencimento. Bloqueio feito hoje conta como válido.
export const isDataValida = (inativoDesde) => {
    if (!inativoDesde) return false;

    const hoje = new Date();
    const hojeISO = `${hoje.getFullYear()}-${String(hoje.getMonth() + 1).padStart(2, '0')}-${String(hoje.getDate()).padStart(2, '0')}`;

    return inativoDesde <= hojeISO;
};
